import { BaseService } from './baseService';
import { PatientRehabProtocolDto, PatientRehabProtocolFormData } from '../types/patientRehabProtocol';

class PatientRehabProtocolService extends BaseService<PatientRehabProtocolDto, PatientRehabProtocolFormData> {
    constructor() {
        super('/PatientRehabProtocol');
    }
}

export const patientRehabProtocolService = new PatientRehabProtocolService();